<div class="sidebar-menus bg-white dark:bg-slate-800 py-2 px-4 h-[calc(100%-80px)] overflow-y-auto z-50 relative"
  id="sidebar_menus">
  <ul class="sidebar-menu">

    <ng-container *ngFor="let item of MenuRoutes; let key = index">
        <li class="sidebar-menu-title" *ngIf="item.title && item.canView">{{item.title}}</li>
        <li class="" [class.active]="item.toggle || isParentActualPage(item)"  *ngIf="!item.title && item.canView">      <!-- (mouseenter)="toggle(item)"
            (mouseleave)="toggle(item)" -->
        <a class="navItem" [routerLink]="(item.childrens && item.childrens.length && item.link ) ? null :  item.link " routerLinkActive="active" [attr.id]="item.name + '-link'"
          [class.dropdown-toggle]="item.childrens && item.childrens.length"
          [attr.role]="item.childrens && item.childrens.length ? 'button' : ''" >
          <span class="flex items-center">
            <iconify-icon *ngIf="item.icon" class="nav-icon" icon="heroicons-outline:{{item.icon}}"></iconify-icon>
            <i  *ngIf="item.customIcon" class="{{item.customIcon}} mr-3"></i>
            <span>{{ item.label }}</span>
          </span>

          <ng-container *ngIf="item.childrens && item.childrens.length">
            <iconify-icon class="icon-arrow" icon="heroicons-outline:chevron-right"></iconify-icon>

          </ng-container>
        </a>
        <ng-container *ngIf="item.childrens && item.childrens.length">
          <ul class="sidebar-submenu" [class.menu-open]="item.toggle || isParentActualPage(item)">

            <ng-container *ngFor="let itemChildren of item.childrens">

              <li>
                <a [routerLink]="itemChildren.link" routerLinkActive='active' [routerLinkActiveOptions]="{exact: true}"
                  *ngIf="itemChildren.link && itemChildren.canView">{{ itemChildren.label }}</a>
              </li>

            </ng-container>
          </ul>
        </ng-container>

      </li>
    </ng-container>

  </ul>
</div>
